/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://m6kd7wi1fc.execute-api.eu-west-1.amazonaws.com/develop",
            "region": "eu-west-1"
        },
        {
            "name": "FileValidationService",
            "endpoint": "https://0ew6nb0w56.execute-api.eu-west-1.amazonaws.com/develop",
            "region": "eu-west-1"
        },
        {
            "name": "S3BucketService",
            "endpoint": "https://5hkzud258c.execute-api.eu-west-1.amazonaws.com/develop",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:d6011aa3-8291-4318-8a04-0b1c27ea8040",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_d9449KkTL",
    "aws_user_pools_web_client_id": "7lseh64qk5jf54su7kdnpef944",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "dev-datapulse-mmscan",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
